export const lereDynamicPricingExclusionsQueryKeys = {
  all: ['lere', 'dynamic-pricing-exclusions'] as const,
  lists: () => [...lereDynamicPricingExclusionsQueryKeys.all, 'list'] as const,
  list: () => [...lereDynamicPricingExclusionsQueryKeys.lists()] as const,
};
